// «Погледајте унутра»: real reviewed pages of Том 1 (media/paginas_ok/, WebP 1080×1350 in the KOŠARKA SPREMNA store Recursos).
// Do NOT use Tom 1 pages 6, 8, 21, 27 (shoe brand logo).
const PAGES = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/5c8ef576-3ab7-4b57-8326-c5c9f2e4dc6d/';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: PAGES + '1792774974399_ks-tom1-strana04-a036705d.webp',
  label: 'Том 1 · Страна 4',
  title: 'Сезона на једној страни',
  text: 'Табела за четири узрасне групе: колико тренинга недељно, колико трају и на шта се ставља фокус.'
}, {
  src: PAGES + '1792774978015_ks-tom1-strana11-d1e992df.webp',
  label: 'Том 1 · Страна 11',
  title: 'Структура тренинга',
  text: 'Загревање → техника → игра → завршни део, са расподелом минута за тренинг од 60, 75 и 90 минута.'
}, {
  src: PAGES + '1792774982034_ks-tom1-strana13-f9e30a54.webp',
  label: 'Том 1 · Страна 13',
  title: 'Тренинг 1 · „Лопта је мој друг“',
  text: 'Школа кошарке 6–10, 60 минута: циљ, материјал, организација и ток тренинга минут по минут.'
}, {
  src: PAGES + '1792774985613_ks-tom1-strana14-0aaad80f.webp',
  label: 'Том 1 · Страна 14',
  title: 'Тренинг 1 · Дијаграм терена',
  text: 'Четири колоне дриблинга кроз чуњеве, упутство за тренера, варијанте у 3 нивоа и безбедност.'
}, {
  src: PAGES + '1792774989556_ks-tom1-strana17-2ad08105.webp',
  label: 'Том 1 · Страна 17',
  title: 'Тренинг 3 · „Мој први двокорак“',
  text: 'Двокорак корак по корак: загревање, техника, вежба, игра и завршни део – укупно 60 минута.'
}, {
  src: PAGES + '1792774993449_ks-tom1-strana24-1d91ba2c.webp',
  label: 'Том 1 · Страна 24',
  title: 'Тренинг 6 · „Додај и сеци“',
  text: 'Дијаграм додавања и сечења ка кошу, кључне речи за тренера и иста вежба у 3 нивоа.'
}];
